import React from "react";
import { isString } from "@common/helpers/typeGuards";
import { Counterparty } from "@common/types/counterparty";
import { TransactionRuleCondition } from "@common/types/transactionRule";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    condition: TransactionRuleCondition;
    counterparties: Counterparty[];
}

export const RuleCounterpartyCondition: React.FC<Props> = ({
    condition,
    counterparties,
}) => {
    const counterpartyIds = isString(condition.value)
        ? [condition.value]
        : (condition.value as string[]);

    const matchedNames = counterparties
        .filter((c) => counterpartyIds.includes(c.id))
        .map((c) => c.name);

    if (!matchedNames.length) {
        return null;
    }

    return (
        <RuleTagRow
            label="Counterparty"
            type="condition"
            values={matchedNames}
        />
    );
};
